import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { IScore } from 'src/app/model/interface/IScore';
import { Item } from 'src/app/model/class/Item';
import { ItemService } from 'src/app/services/item.service';
import { ScoreService } from 'src/app/services/score.service';
import { NavController } from '@ionic/angular';
import { itemAnimation } from '../animations/item-animation';
import { AlertService } from 'src/app/services/alert.service';
import { UserService } from 'src/app/services/user.service';
import { FeedbackFirebaseService } from 'src/app/services/feedback-firebase.service';

@Component({
  selector: 'app-question-base',
  templateUrl: './question-base.component.html',
  styleUrls: ['./question-base.component.scss'],
})
export class QuestionBaseComponent implements OnInit {
  item: Item;
  nItem = 1;
  transItem = [13, 25];
  score: IScore[];
  stateItem = true;
  txtComment = '';
  imgBack = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private itemService: ItemService,
    private scoreService: ScoreService,
    private navCtrl: NavController,
    private alertService: AlertService,
    private userService: UserService,
    private feedbackFirebaseService: FeedbackFirebaseService
  ) {
    this.nItem = this.convertStringToNumber(sessionStorage.getItem('numItem'));
    this.validateItem();
    //this.navCtrl.setDirection('root', false, 'forward');
    //this.navCtrl.setDirection('root', true, 'forward', itemAnimation);
  }

  private validateItem() {
    if (isNaN(this.nItem)) {
      this.scoreService.deleteScore();
      this.nItem = 1;
      sessionStorage.setItem('numItem', '1');
    }
  }

  private loadQuestion(idItem: number) {
    this.item = this.itemService.getItem(idItem);
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      if (params.has('idItem')) {
        this.setBackground();
        const param = params.get('idItem');
        if (
          this.nItem == this.convertStringToNumber(param) &&
          this.nItem == 35
        ) {
          this.stateItem = false;
        } else if (this.nItem == this.convertStringToNumber(param)) {
          this.stateItem = true;
          this.loadQuestion(this.nItem);
        } else {
          this.router.navigate(['test/item', this.nItem]);
        }
      }
    });
  }

  addCommentFirestore(comment: string) {
    this.feedbackFirebaseService.addFeedback({ comment });
  }

  nextItem() {
    const checkedValue = document.getElementById(`${this.item.id}`)['value'];
    if (checkedValue == undefined) {
      this.alertService.presentAlert(
        '¡ATENCIÓN!',
        'Por favor seleccionar una respuesta'
      );
    } else {
      this.scoreService.addScore(
        `${this.item.id}`,
        this.convertStringToNumber(checkedValue)
      );
      this.nItem++;
      // console.log(this.nItem);
      sessionStorage.setItem('numItem', `${this.nItem}`);
      if (this.transItem.includes(this.nItem)) {
        // console.log('true');
        let state = { nItem: this.nItem };
        let navigationExtras: NavigationExtras = {
          state,
          queryParams: {
            nItem: this.nItem,
          },
        };
        this.router.navigate(['test/transitions'], navigationExtras);
      } else {
        this.router.navigate(['test/item', this.nItem]);
      }
    }
  }

  private convertStringToNumber(n: string): number {
    return Number.parseInt(n);
  }

  getMarginTitleQuestion() {
    return this.item.answer.length == 2 ? '60px' : '20px';
  }

  getColorTitleQuestion() {
    return this.item.answer.length == 2 ? '#1E2CFB' : '#3D41B6';
  }

  getColorBorderTitleQuestion() {
    return this.item.answer.length == 2
      ? '3px solid #1E2CFB'
      : '3px solid #3D41B6';
  }

  setBackground() {
    if (this.nItem <= 5) {
      this.imgBack = '/assets/img/fondos/experiencia.png';
    } else if (this.nItem > 5 && this.nItem <= 12) {
      this.imgBack = '/assets/img/fondos/percepcion.png';
    } else if (this.nItem >= 13 && this.nItem <= 20) {
      this.imgBack = '/assets/img/fondos/procesamiento.png';
    } else if (this.nItem >= 21 && this.nItem <= 25) {
      this.imgBack = '/assets/img/fondos/planificacion.png';
    } else if (this.nItem >= 26 && this.nItem <= 32) {
      this.imgBack = '/assets/img/fondos/sociales.png';
    } else if (this.nItem > 32) {
      this.imgBack = '/assets/img/fondos/uso.png';
    }
  }

  getResults() {
    this.addCommentFirestore(this.txtComment);
    this.userService.changeRoleUser('readResult');
    this.router.navigate(['results', 1]);
  }
}
